import React from "react";
import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  const policies = [
    {
      title: "1. Information We Collect",
      text: "We may collect basic account information such as name, email address, mobile number, and login details during registration. Subscription status and account access information may also be recorded to manage user services."
    },
    {
      title: "2. Data Storage & Security",
      text: "User account and subscription-related data are stored using Firebase infrastructure and protected through standard security practices. We take reasonable steps to reduce unauthorized access, misuse, or disclosure."
    },
    {
      title: "3. Data Sharing Policy",
      text: "We do not sell, rent, or trade personal user information. Data is used only for account functionality, learning access, subscription management, communication, and service improvement."
    },
    {
      title: "4. Subscription & Payment Information",
      text: "Payments are processed through secure third-party payment gateways. We do not store sensitive financial information such as debit card numbers, credit card details, CVV, or UPI PIN on our servers."
    },
    {
      title: "5. User Rights",
      text: "Users may request account updates, correction of profile details, or account deletion subject to platform and legal requirements. Requests can be managed through account support channels."
    }
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        background:
          "radial-gradient(circle at top left, rgba(34,197,94,0.07), transparent 22%), radial-gradient(circle at top right, rgba(56,189,248,0.08), transparent 24%), linear-gradient(135deg, #020617, #0f172a, #111827)",
        color: "#fff"
      }}
    >
      <div className="container py-5">
        <div className="text-center mb-5">
          <div style={badgeStyle}>USER DATA & SECURITY</div>

          <h1
            className="fw-bold mt-4"
            style={{
              fontSize: "clamp(2rem, 5vw, 3.2rem)",
              background: "linear-gradient(90deg, #ffffff, #cbd5e1, #38bdf8)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }}
          >
            Privacy Policy
          </h1>

          <p
            className="mx-auto mt-3"
            style={{
              maxWidth: "860px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              fontSize: "1.03rem"
            }}
          >
            At UPSC Titan Score, protecting user privacy and maintaining
            responsible data practices is an important part of our platform
            experience.
          </p>
        </div>

        <div className="row g-4">
          {policies.map((item, index) => (
            <div className="col-12" key={index}>
              <div style={sectionCardStyle}>
                <h4 className="fw-bold mb-3" style={{ color: "#f8fafc" }}>
                  {item.title}
                </h4>
                <p style={textStyle}>{item.text}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 text-center" style={ctaStyle}>
          <div style={badgeStyle}>TRUST & TRANSPARENCY</div>
          <h4 className="fw-bold mt-3 mb-3" style={{ color: "#ffffff" }}>
            Your Learning Journey Should Also Feel Secure
          </h4>
          <p
            className="mx-auto"
            style={{
              maxWidth: "860px",
              color: "#cbd5e1",
              lineHeight: "1.9",
              marginBottom: "22px"
            }}
          >
            By using UPSC Titan Score, you agree to the practices described in
            this Privacy Policy. We aim to keep our systems simple, secure, and
            respectful of user trust.
          </p>

          <div className="d-flex flex-wrap justify-content-center gap-3">
            <Link to="/terms" className="btn btn-outline-light btn-lg px-4">
              Terms & Conditions
            </Link>
            <Link to="/disclaimer" className="btn btn-success btn-lg px-4">
              Disclaimer
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

const badgeStyle = {
  display: "inline-block",
  padding: "8px 16px",
  borderRadius: "999px",
  background: "rgba(56,189,248,0.12)",
  border: "1px solid rgba(56,189,248,0.20)",
  color: "#7dd3fc",
  fontWeight: 700,
  fontSize: "13px",
  letterSpacing: "1px"
};

const sectionCardStyle = {
  background:
    "linear-gradient(145deg, rgba(15,23,42,0.92), rgba(17,24,39,0.88))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "24px",
  padding: "26px",
  boxShadow: "0 14px 34px rgba(0,0,0,0.24)"
};

const textStyle = {
  color: "#94a3b8",
  lineHeight: "1.9",
  fontSize: "0.98rem",
  marginBottom: 0
};

const ctaStyle = {
  background:
    "linear-gradient(145deg, rgba(2,6,23,0.96), rgba(15,23,42,0.92))",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "30px",
  padding: "42px 24px",
  boxShadow: "0 18px 40px rgba(0,0,0,0.28)"
};